import { useParams } from 'react-router-dom';

import { appManagementActions } from '@/redux/actions';
import { SavePageContainer } from '@/components';
import AppForm from './AppForm';
import paths from '@/constants/paths';

const SavePage = () => {
    const {id} = useParams();
    const isCreating = !id;

    const getBreadcrumbs = (data) => {
        return [
            {breadcrumbName: 'App Management', path: paths.appManagementList},
            {breadcrumbName: isCreating ? 'New' : data.name, path: 'avoidDuplicateKey'},
        ];
    }

    return (
        <SavePageContainer
            form={AppForm}
            isCreating={!id}
            objectName="App"
            listUrl={paths.appManagementList}
            detailUrl={paths.appManagementDetail}
            createAction={appManagementActions.create}
            updateAction={appManagementActions.update}
            getDetailAction={appManagementActions.getDetail}
            getBreadcrumbs={getBreadcrumbs}
            isRefreshUpdateSuccess={true}
        />

    )
}

export default SavePage;